import useWidth from '@components/Hooks/useWidth';
import EmptyState from '@components/v2/ui/EmptyState/EmptyState';
import EmptyStateWrapper from '@components/v2/ui/EmptyState/EmptyStateWrapper';
import OrdersIllustration from '@components/v2/ui/EmptyState/svg/OrdersIllustration';
import { Stack } from '@mui/material';
import LangEnum from '../../../../../../../lang/LangEnum';
import { OrderConditionsTestIds } from '../../../../../../../utils/testIds/OrderConditions.testIds';

const CONTENT_INDENT = 10;

interface OrderConditionsEmptyStateProps {
  isReadOnlyView: boolean;
}

const OrderConditionsEmptyState = ({ isReadOnlyView }: OrderConditionsEmptyStateProps) => {
  const { smallWidth } = useWidth();

  const emptyState = (
    <EmptyState
      testId={OrderConditionsTestIds.TAB_EMPTY_STATE}
      title={{ text: LangEnum.ORDER_CONDITIONS_EMPTY_TITLE }}
      illustration={<OrdersIllustration />}
      description={{
        text: isReadOnlyView
          ? LangEnum.ORDER_CONDITIONS_EMPTY_READ_ONLY_DESCRIPTION
          : LangEnum.ORDER_CONDITIONS_EMPTY_DESCRIPTION,
      }}
    />
  );

  if (smallWidth) {
    return <EmptyStateWrapper>{emptyState}</EmptyStateWrapper>;
  }

  return (
    <Stack
      sx={{
        justifyContent: 'center',
        alignItems: { xs: 'center', md: 'flex-start' },
        ml: { xs: 0, md: CONTENT_INDENT },
        px: { xs: 3, md: 0 },
      }}
    >
      {emptyState}
    </Stack>
  );
};

export default OrderConditionsEmptyState;
